export const moveArrayElements = (arr: any[], from: number, to: number) => {
    const array = [...arr];
    const startIndex = from < 0 ? array.length + from : from;
    if (startIndex >= 0 && startIndex < array.length) {
        const endIndex = to < 0 ? array.length + to : to;
        const [item] = array.splice(from, 1, undefined); // Keep array length the same to keep insertion the same
        array.splice(endIndex, 0, item);
        return array.filter(Boolean);
    }
    return array;
};
